"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RatingList {
    constructor(client) {
        this.client = client;
    }
    getRatings() {
        return new Promise(async (resolve, reject) => {
            try {
                const { coachRatings: { items }, } = await this.client.fetch("coachRatings", `query coachRatings {
                coachRatings {  items {
                    id
                    rating
                    comment
                    date {
                      iso8601
                    }
                }}
            }`, {});
                resolve(items.map(({ id, rating, comment, date: { iso8601 } }) => ({
                    id: id.toString(),
                    rating: (rating || 0),
                    comment: comment || undefined,
                    dateTime: iso8601,
                })));
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
exports.default = RatingList;
//# sourceMappingURL=RatingList.js.map